import styled from 'styled-components';
import clock from '~/assets/icons/clock.svg';
import line from '../../assets/images/line.svg';

const StyledWrapper = styled.div`
	opacity: 0;
	transition: opacity 0.5s ease 0.1s;
`;

const StyledDeathContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const StyledLine = styled.div`
	width: 286px;
	height: 12px;
	margin-top: 10px;
	background-image: url(${line});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledBottomContainer = styled.div`
	position: absolute;
	left: 50%;
	bottom: 100px;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

const StyledTimer = styled.div`
	width: 18px;
	height: 20px;
	mask-image: url(${clock});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: 18px 20px;
	-webkit-mask-image: url(${clock});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 18px 20px;
	background-color: #fabe2c;
`;

export {
	StyledWrapper,
	StyledDeathContainer,
	StyledLine,
	StyledBottomContainer,
	StyledTimerContainer,
	StyledTimer,
};
